import { combineReducers } from 'redux';
import TermsReducer from './reducer_terms';
import FavouritesReducer from './reducer_favourites';
import messageReducer from './reducer_message_modal';

const rootReducer = combineReducers({
    mathsDictionary: TermsReducer,
    messageState: messageReducer,
    favourites: FavouritesReducer
});

export default rootReducer;
